import {
  selectIsDeletingImpactCo2Answer,
  selectIsFetchingImpactCo2Answers,
  selectIsSubmitingImpactCo2Answer,
} from '@/domain/impact-co2/impact-co2.selectors';
import { useAppSelector } from '@/ui/hook/store';

export function useImpactCo2AnswerSubmitDisabled() {
  const isSubmiting = useAppSelector(selectIsSubmitingImpactCo2Answer);
  const isFetching = useAppSelector(selectIsFetchingImpactCo2Answers);
  const isDeleting = useAppSelector(selectIsDeletingImpactCo2Answer);
  const disableSubmitActions = isSubmiting || isFetching || isDeleting;

  return { disableSubmitActions };
}
